import React from "react";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Policies.css";

const TermsPage = () => (
  <>
    <Navbar />
    <main className="hn-policies-main">
      <Container className="py-4 py-md-5">
        <p className="hn-policies-updated">Last Updated: 2026-03-12</p>
        <h1 className="hn-policies-title">Terms of Use</h1>
        <div className="hn-policies-body">
          <p>
            By accessing or purchasing services from Hosting Noodle, you agree to comply with these Terms of Use. If you do not agree with these terms, you must not use our services.
          </p>
          <p>
            Hosting Noodle provides remote computing environments, processing instances, and licensed runtime software environments. All services are provided &quot;as‑is&quot; and &quot;as available&quot;. We reserve the right to modify, suspend, or discontinue services at any time.
          </p>
          <p>
            Users must provide accurate account information and are responsible for maintaining the confidentiality of their credentials.
          </p>
          <p>
            Users agree to use the services only for lawful purposes and must not misuse infrastructure or attempt to disrupt the platform.
          </p>
          <p>
            Certain services require manual deployment or configuration. Users may be asked to provide remote access credentials or respond to setup requests.
          </p>
          <p>
            If a user fails to respond to required deployment communication within 3 days, Hosting Noodle may delay, cancel, or suspend the deployment without refund.
          </p>
          <p>
            Service availability is not guaranteed. Maintenance, infrastructure issues, or external provider interruptions may cause downtime.
          </p>
          <p>
            Hosting Noodle reserves the right to suspend or terminate services if a user violates these terms or engages in activities that may harm the platform or its partners.
          </p>
        </div>
      </Container>
    </main>
    <Footer />
  </>
);

export default TermsPage;
